<template>
    <div class="container">
        <div class="row justify-content-md-center">
            <div class="col-md-5">
                <h2>Úprava poruchy svietidla</h2>
                <div class="card">
                    <div class="text-center" v-show="isLoading">
                        <font-awesome-icon :icon="['fas', 'spinner']" spin />
                    </div>
                    <div class="card-body" v-show="!isLoading">
                        <b-form @submit="onSubmit">
                            <b-form-group label="Riešenia">
                                <b-form-checkbox-group
                                    v-model="reported.defect_solutions"
                                    :options="options"
                                    :state="validateSolutions"
                                    :disabled="
                                        reported.defect_solutions ? reported.defect_solutions.includes(999) : false
                                    "
                                    name="defect_solutions"
                                    stacked
                                ></b-form-checkbox-group>
                                <b-form-invalid-feedback :state="validateSolutions">
                                    Vyberte aspoň jedno riešenie
                                </b-form-invalid-feedback>
                            </b-form-group>


                            <b-form-group label="Typ">
                                <b-form-radio-group
                                    v-model="reported.defect_type_id"
                                    :options="typeOptions"
                                    :state="validateTypes"
                                    name="defect_type_id"
                                    stacked
                                ></b-form-radio-group>
                                <b-form-invalid-feedback :state="validateTypes">
                                    Vyberte typ
                                </b-form-invalid-feedback>
                            </b-form-group>

                            <br />
                            <b v-if="reported.note">Popis problému:</b>
                            <p>{{ reported.note }}</p>

                            <b v-if="reported.defects">Hlásené poruchy:</b>
                            <p>{{ reported.defects }}</p>

                            <label for="textarea"
                                ><b>Popis odstránenia závady, cena, ...</b></label
                            >
                            <b-form-textarea
                                id="textarea"
                                v-model="reported.solution_note"
                                placeholder="Vložte text"
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>
                            <br />
                            <b-button
                                type="submit"
                                block
                                variant="primary"
                                :disabled="!validateSolutions"
                                >Odoslať
                            </b-button>
                        </b-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BFormGroup, BFormCheckboxGroup, BFormTextarea } from "bootstrap-vue";
import {
    UPDATE_REPORTED,
    FETCH_DEFECT_SOLUTIONS,
    FETCH_REPORTED
} from "../../vuex/modules/actions.type";
import { mapGetters } from "vuex";
import { DefectTypesService } from "@/common/defectTypes.service"

export default {
    name: "DefectsEdit",
    data() {
        return {
            defect: null,
            invalid: false,
            typeOptions: {},
            reportedDefect: {
                defect_solutions: [],
                solution_note: ""
            }
        };
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault();

            this.$store
                .dispatch(UPDATE_REPORTED)
                .then(data => {
                    let toastText =
                        data.status == 200
                            ? "Záznam úspešne uložený"
                            : "Nastala chyba";

                    this.$swal({
                        icon: data.status == 200 ? "success" : "danger",
                        title: '',
                        text: toastText
                    });
                })
                .catch(({ response }) => {
                    this.inProgress = false;
                    this.errors = response.data.errors;
                });
        },

        fetchReported() {
            this.$store.dispatch(FETCH_REPORTED, {
                id: this.$route.params.id
            });
        },

        fetchDefectSolutions() {
            this.$store.dispatch(FETCH_DEFECT_SOLUTIONS);
        },

        fetchDefectTypes() {
            DefectTypesService.query()
                .then(resp => {
                    this.typeOptions = resp.data
                })
                .catch(err => {
                    // todo
                });
        }
    },

    mounted() {
        this.fetchReported();
        this.fetchDefectSolutions();
        this.fetchDefectTypes();
    },
    computed: {
        ...mapGetters({
            reported: "reported",
            options: "allSolutions",
            isLoading: "isLoading"
        }),

        validateSolutions() {
            return (
                this.reported.defect_solutions != undefined &&
                this.reported.defect_solutions.length > 0
            );
        },
        validateothers() {
            return (
                this.reported.defect_solutions != undefined &&
                this.reported.others != undefined &&
                this.reported.defect_solutions.indexOf(-1) >= 0 &&
                this.reported.others.length > 0
            );
        },
        validateTypes() {
            return (
                this.reported.defect_type_id != undefined
            );
        },
        selectOthers() {
            return (
                this.reported.defect_solutions != undefined &&
                this.reported.defect_solutions.indexOf(-1)
            );
        }
    },
    components: {
        "b-form-group": BFormGroup,
        "b-form-checkbox-group": BFormCheckboxGroup,
        "b-form-textarea": BFormTextarea
    }
};
</script>

<style scoped></style>
